/**
 * 关系模型 —— 连接不是画一根线，而是建立对象关系图。
 * 对应技术设计 §5.4。
 */

/**
 * 关系类型。**19 种，与技术设计 §5.4（`:553-573`）完全一致，不得增删改名**。
 * 少一种就意味着某类实验无法只靠配置实现（§22 红线 12「原语覆盖优先于特例代码」）。
 */
export type RelationType =
  | "connect"
  | "insert"
  | "clamp"
  | "place"
  | "seal"
  | "heat"
  | "ignite"
  | "pour"
  | "drop"
  | "stir"
  | "dissolve"
  | "filter"
  | "evaporate"
  | "collect"
  | "weigh"
  | "measure"
  | "power"
  | "test"
  | "compare";

/** 契约自检用：运行期可枚举的关系类型全集。 */
export const RELATION_TYPES: readonly RelationType[] = [
  "connect",
  "insert",
  "clamp",
  "place",
  "seal",
  "heat",
  "ignite",
  "pour",
  "drop",
  "stir",
  "dissolve",
  "filter",
  "evaporate",
  "collect",
  "weigh",
  "measure",
  "power",
  "test",
  "compare",
] as const;

export interface Endpoint {
  objectId: string;
  portId?: string;
  slotId?: string;
}

/** 连接后的跟随约束（§5.5），求解器在 P1 落地。 */
export interface Constraint {
  kind: string;
  params?: Record<string, unknown>;
}

export interface Relation {
  id: string;
  type: RelationType;
  from: Endpoint;
  to: Endpoint;
  state: "preview" | "active" | "broken";
  constraints?: Constraint[];
  createdAt: number;
  createdBy: "user" | "mission" | "system";
}

export function endpointKey(endpoint: Endpoint): string {
  const anchor = endpoint.portId ?? endpoint.slotId;
  return anchor ? `${endpoint.objectId}.${anchor}` : endpoint.objectId;
}

/**
 * 端点匹配：只声明了 objectId 的查询条件，匹配该对象上的任意端口/槽位。
 * 声明了 portId/slotId 的，必须完全一致。
 */
export function endpointMatches(actual: Endpoint, query: Endpoint): boolean {
  if (actual.objectId !== query.objectId) return false;
  if (query.portId !== undefined && actual.portId !== query.portId) return false;
  if (query.slotId !== undefined && actual.slotId !== query.slotId) return false;
  return true;
}
